import { graphql, useFragment } from "react-relay";

import type { useDocsUrl_query$key } from "./__generated__/useDocsUrl_query.graphql";

/**
 * Resolves links into this deployment's documentation site. The returned
 * function joins a docs path onto the site's URL, or gives null where no docs
 * site is deployed so the caller can leave its link out. `path` is
 * site-relative and starts with a slash, such as `/how-to/configure-sso/`.
 */
export function useDocsUrl(
  queryRef: useDocsUrl_query$key,
): (path: string) => string | null {
  const data = useFragment(
    graphql`
      fragment useDocsUrl_query on Query {
        UrlConfig {
          docs
        }
      }
    `,
    queryRef,
  );

  const docs = data.UrlConfig?.docs;
  // The configured URL may or may not end with a slash; paths start with one.
  return (path) => (docs ? `${docs.replace(/\/+$/, "")}${path}` : null);
}
